import React, { useEffect, useState, useRef } from 'react'
import Api from '../api.js';
import { Link, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Alerts, { registerOnAlertVisible } from './Alerts.js';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { ThemeProvider, createTheme } from '@mui/material/styles';


export default function Tabla({ info, noQueries = false, noFilter = false, preSearch = false, filter = [], openVisor = false, forceRender, search, bande, style = [] }) {
    let api = new Api();
    let infoUsuario = useSelector((state) => state.infoUsuario.value);
    let infoGeneral = useSelector((state) => state.infoGeneral.value);
    let location = useLocation();

    let [tableInfo, setTableInfo] = useState([]);
    let [pages, setPages] = useState(1);
    let [sort, setSort] = useState({ by: "", order: "" });
    let page = useRef(1);
    let searchParameter = useRef("");
    let listStatus = useRef(1);

    let [searchValue, setSearchValue] = useState('')
    const filtroSeleccionado = useRef(null);
    const [typed, setTyped] = useState(false);
    const [showError, setShowError] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [alertMessage2, setAlertMessage2] = useState('');
    const [showBotton, setShowBotton] = useState(false);
    const [data, setData] = useState();

    useEffect(() => {
        if (search && search.length >= 3) setSearchValue(search);
    }, [])

    useEffect(() => {
        if (searchValue !== "") {
            setTyped(true);
        }
        const timer = setTimeout(() => {
            if (searchValue !== "" || typed) {
                listar();
            }
        }, 500)

        return () => clearTimeout(timer)
    }, [searchValue])

    const cerrarError = () => {
        setShowError(false);
    };

    const errorHandler = async (data) => {
        try {
            const data = await fetch('endpoint');

            if (data.flag === 1 && data.timer === 0) {
                setAlertTitle('Error de carga');
                setAlertMessage(`No se pudo cargar la visualización del archivo. Intenta refrescar la página o cargarlo nuevamente.`);
                setShowError(true);
                setShowBotton(false);
            } else {
                if (data.flag === 0 && data.timer != 0) {
                    setAlertTitle('El examen estará disponible muy pronto');
                    setAlertMessage(`El archivo ${data.name} se está preparando y podrás visualizarlo en aproximadamente ${data.timer} horas.`);
                    setAlertMessage2(`¡Gracias por tu paciencia! Te avisaremos en cuanto esté listo.`)
                    setShowBotton(false);
                } else {
                    if (data.flag === 0 && data.timer === 0) {
                        setAlertTitle('Este archivo tiene más de un año de almacenamiento');
                        setAlertMessage(`El archivo ${data.name} estará disponible para su visualización en 12 horas.`);
                        setAlertMessage2(`Si desea iniciar el proceso, haga clic en Aceptar y le notificaremos cuando el examen esté listo.`);
                        setShowBotton(true);
                        setData(data);
                    }
                }
                setShowError(true);
            }
        } catch (error) {
            setAlertTitle('Error de carga!');
            setAlertMessage('No se pudo cargar la visualización del archivo. Intenta refrescar la página o cargarlo nuevamente');
            setShowError(true);
            setShowBotton(false);
        }
    }


    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         listar()
    //     }, 500)

    //     return () => clearTimeout(timer)
    // }, [searchValue]);


    useEffect(() => {
        if (infoUsuario.token !== null) {
            listar();
        }
    }, [infoUsuario, sort, forceRender, preSearch]);


    async function listar() {
        const pagina = getPageValue();
        console.log("EL presearch es " + preSearch)

        if (preSearch == "noBuscar") {
            return;
        }
        let filter = {};
        filter.statusId = parseInt(listStatus.current.value);
        if (preSearch) {
            filter.documentType = 1;
        }

        let endpoint2;
        if (noFilter) {
            const connector = info.endpoint.includes('?') ? '&' : '?';
            endpoint2 = info.endpoint + connector + 'page=' + pagina;
        } else {
            endpoint2 = info.endpoint + '?page=' + pagina + '&filter=' + JSON.stringify(filter);
        }

        if (bande == 1 && searchParameter.current.value == "") {
            localStorage.setItem('busqueda', searchParameter.current.value);
        }

        if (searchParameter.current.value !== "") {
            if (searchParameter.current.value.length < 3) {
                return;
            }
            endpoint2 += '&search=' + searchParameter.current.value;
            if (bande === 1) localStorage.setItem('busqueda', searchParameter.current.value);

        }

        if (preSearch != false) {
            endpoint2 += '&filter={"patientId":' + preSearch + '}';
        }

        if (sort.by !== "") {
            endpoint2 += '&order=' + JSON.stringify([[sort.by, sort.order]]);
        }

        if (noQueries) {
            endpoint2 = info.endpoint;
        }
        console.log(endpoint2)
        var resp = await api.get(endpoint2, infoUsuario.token);

        if (!resp.error) {
            if (info.infoInKey) {
                setTableInfo(resp.info[info.infoInKey]);
            } else {
                setTableInfo(resp.info);
            }

            if (resp.pages == 0) {
                setPages(1);
            } else {
                setPages(resp.pages);
            }

        }
    }

    async function filtrar(val = null) {

        const pagina = getPageValue();

        // Guardar el filtro si se pasa uno nuevo
        if (val) filtroSeleccionado.current = val;

        let filter = {};
        if (filtroSeleccionado.current) {
            filter.statusId = filtroSeleccionado.current.value;
        }

        let endpoint2;
        const connector = info.endpoint.includes('?') ? '&' : '?';

        // Verificar si ya hay filtros en el endpoint original
        const existingFilterMatch = info.endpoint.match(/filter=({.*?})/);
        if (existingFilterMatch) {
            const existingFilter = JSON.parse(decodeURIComponent(existingFilterMatch[1]));
            filter = { ...existingFilter, ...filter };
            endpoint2 = info.endpoint.replace(/filter=({.*?})/, '') + connector + 'page=' + pagina + '&filter=' + encodeURIComponent(JSON.stringify(filter));
        } else {
            endpoint2 = info.endpoint + '?page=' + pagina + '&filter=' + encodeURIComponent(JSON.stringify(filter));
        }

        const resp = await api.get(endpoint2, infoUsuario.token);

        if (!resp.error) {
            if (info.infoInKey) {
                setTableInfo(resp.info[info.infoInKey]);
            } else {
                setTableInfo(resp.info);
            }

            setPages(resp.pages === 0 ? 1 : resp.pages);
        }
    }

    const createUrl = (text, info) => {
        let result = [];
        let currentText = "";
        let inVariable = false;

        for (let i = 0; i < text.length; i++) {
            let char = text[i];
            if (char === "$") {
                if (inVariable) {
                    result.push({ type: "variable", value: currentText });
                    currentText = "";
                    inVariable = false;
                } else {
                    result.push({ type: "text", value: currentText });
                    currentText = "";
                    inVariable = true;
                }
            } else {
                currentText += char;
            }
        }

        if (currentText) {
            result.push({ type: inVariable ? "variable" : "text", value: currentText });
        }

        result = result.map((section) => {
            if (section.type == "text") {
                return section.value;
            } else {
                return info[section.value];
            }
        }).join("");

        return result;
    }

    async function toggleStatus(event, id, url) {
        var t = window.confirm("Esta seguro que desea cambiar el estado?");

        if (t !== true) {
            return;
        }
        let data;
        data = { statusId: parseInt(event.target.value) }

        var resp = await api.put(url + "/" + id, data, infoUsuario.token);

        if (!resp.error) {
            listar();
        }
    }

    async function sortFunc(sortBy) {
        if (sort.by == sortBy) {
            if (sort.order == "ASC") {
                setSort({ by: sortBy, order: "DESC" })
            } else {
                setSort({ by: sortBy, order: "ASC" })
            }
        } else {
            setSort({ by: sortBy, order: "ASC" })
        }
    }

    const previewer = async (rec) => {
        const url = `https://api.dentyview.com/order/file/download/${rec}`

        const resp = await fetch(url, {
            method: 'GET',
        });

        return resp;
    }

    function helperdcm(input) {
        let arr;
        if (Array.isArray(input)) {
            arr = input;
        } else if (typeof input === "string") {
            try {
                arr = JSON.parse(input);
            } catch {
                const m = input.match(/([a-z][\w.-]*\.)?com\/[^\s",\]]+/i);
                if (!m) return "";
                arr = [m[0]];
            }
        } else {
            return "";
        }

        if (!arr.length) return "";
        const first = String(arr[0]);
        const m = first.match(/\.com\/(.*)$/i);
        return m ? m[1] : "";
    }

    let controls = "pageSubHeading";
    if (noQueries) {
        controls = "pageSubHeadingHidden";
    }

    let filterVisible = "none";
    if (filter.length !== 0) {
        filterVisible = "flex";
    }
    let [isSearching, setIsSearching] = useState(false);
    if (preSearch) {
        if (!isSearching) {
            filter = "documentType";
            listar();
            setIsSearching(true);
        }
    }

    const downloadFile = async (url, fileName = "archivo") => {
        try {
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error("No se pudo descargar el archivo");
            }

            const blob = await response.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

        } catch (error) {
            console.error("Error descargando archivo:", error);
        }
    };

    function getPageValue() { return Number(page.current ?? 1); }

    const theme = createTheme();

    return (
        <>
            <div className={controls} style={style}>
                <input type="search" className="searchInput" placeholder="Buscar" ref={searchParameter} onChange={e => setSearchValue(e.target.value)} value={searchValue} />

                <Select styles={{ container: (base) => ({ ...base, width: "40%", display: filterVisible }) }} onChange={(val) => { filtrar(val); }} options={filter} />

                {/* <div><span class="pageSelectorText">Página</span> <select className="pageSelector" ref={page} onChange={() => filtrar()}>{Array.from(Array(pages), (e, i) => { return <option key={i + 1} value={i + 1}>{i + 1}</option> })}</select> de {pages}</div> */}

                <div styles={"padding-right: 40px"}>
                    <ThemeProvider theme={theme}>
                        <Box
                            sx={{
                                '& > *': { mt: 2 },
                                '& .MuiPagination-ul': {
                                    flexWrap: 'nowrap',
                                    justifyContent: { xs: 'center', md: 'left' },
                                },
                                overflowX: 'auto',
                                px: { xs: 12, md: 12 },
                                py: 0.5,
                                // compacta en móvil
                                '& .MuiPaginationItem-root': {
                                    minWidth: { xs: 10, sm: 18 },
                                    height: { xs: 18, sm: 18 },
                                    mx: 0.25,
                                },
                                // seleccionado con primary + sombra
                                '& .MuiPaginationItem-root.Mui-selected': (t) => ({
                                    backgroundColor: t.palette.primary.main,
                                    color: t.palette.primary.contrastText,
                                    boxShadow: `0 0 0 3px ${t.palette.primary.main}33 inset`,
                                    '&:hover': { backgroundColor: t.palette.primary.dark },
                                }),
                            }}
                        >
                            <Pagination
                                count={pages}
                                size="small"
                                page={Number(page.current) || 1}
                                siblingCount={1}
                                boundaryCount={1}
                                showFirstButton
                                showLastButton
                                onChange={(_, value) => {
                                    page.current = Number(value) || 1;
                                    filtrar();
                                }}
                                renderItem={(item) => {
                                    if (item.type === 'start-ellipsis') {
                                        const target = Math.max(1, (Number(page.current) || 1) - 10);
                                        return (
                                            <PaginationItem
                                                {...item}
                                                type="page"
                                                page={target}
                                                onClick={() => {
                                                    page.current = target;
                                                    filtrar();
                                                }}
                                            >
                                                «10
                                            </PaginationItem>
                                        );
                                    }

                                    if (item.type === 'end-ellipsis') {
                                        const target = Math.min(pages, (Number(page.current) || 1) + 10);
                                        return (
                                            <PaginationItem
                                                {...item}
                                                type="page"
                                                page={target}
                                                onClick={() => {
                                                    page.current = target;
                                                    filtrar();
                                                }}
                                            >
                                                10»
                                            </PaginationItem>
                                        );
                                    }

                                    return <PaginationItem {...item} />;
                                }}
                            />
                        </Box>
                    </ThemeProvider>
                </div>
            </div>
            <div className="tableContainer" style={style}>
                <table>
                    <thead>
                        <tr>
                            {info.titulos.map((titulo, index) => {
                                if (titulo.name == "status") {
                                    return <th key={index}><select className="statusSelect" ref={listStatus} onChange={listar}>{infoGeneral.status.map((status, index2) => { return <option key={index2} value={status.id}>{status.name}</option> })}</select></th>;
                                } else {
                                    if (titulo.name) {
                                        return <th key={index} onClick={() => { sortFunc(titulo.name) }}>{titulo.texto}</th>
                                    } else {
                                        return <th key={index}>{titulo.texto}</th>
                                    }

                                }
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {tableInfo.map((row, index) => {
                            return <tr key={index}>
                                {info.columnas.map((col, index) => {
                                    if (col["type"] == "text") {
                                        let v;
                                        if (col["nested"]) {
                                            v = row[col["prop"]][col.nested];
                                        } else {
                                            v = row[col["prop"]];
                                        }

                                        if (openVisor && col["openVisor"]) {
                                            if (col["format"]) {
                                                return <td key={index} onClick={async () => {
                                                    // try {
                                                    //     let valor;
                                                    //     let resp;
                                                    //     try {
                                                    //         valor = JSON.parse(row["file"]);
                                                    //         valor = row.filenameKey;
                                                    //     } catch (e) {
                                                    //         valor = row.filenameKey;
                                                    //     }
                                                    //     if (valor == "archivo_dicom.dcm"){
                                                    //         valor = helperdcm(row.file)
                                                    //         console.log(helperdcm(row.file));
                                                    //     }
                                                    //     console.log(row, 'antes de entrar');
                                                    //     try {
                                                    //         resp = await previewer(valor);
                                                    //         console.log("Respuesta OK:", resp);
                                                    //     } catch (error) {
                                                    //         console.log("Error al hacer la petición:", error);
                                                    //     }
                                                    //     if (resp.ok) {
                                                    //         openVisor(row["fileMimetype"], row["file"], row["id"])
                                                    //         console.log(row);
                                                    //     } else {
                                                    //         setShowError(true);
                                                    //     }
                                                    // } catch (error) {
                                                    //     setShowError(true);
                                                    // }
                                                    openVisor(row["fileMimetype"], row["file"], row["id"])
                                                }}>{col["format"](v)}</td>
                                            } else {
                                                return <td key={index} onClick={async () => {
                                                    // try {
                                                    //     let valor;
                                                    //     let resp;
                                                    //     try {
                                                    //         valor = JSON.parse(row["file"]);
                                                    //         valor = row.filenameKey;
                                                    //     } catch (e) {
                                                    //         valor = row.filenameKey;
                                                    //     }
                                                    //     if (valor == "archivo_dicom.dcm"){
                                                    //         valor = helperdcm(row.file)
                                                    //         console.log(helperdcm(row.file));
                                                    //     }
                                                    //     console.log(row, 'antes de entrar');
                                                    //     try {
                                                    //         resp = await previewer(valor);
                                                    //         console.log("Respuesta OK:", resp);
                                                    //     } catch (error) {
                                                    //         console.log("Error al hacer la petición:", error);
                                                    //     }
                                                    //     if (resp.ok) {
                                                    //         openVisor(row["fileMimetype"], row["file"], row["id"])
                                                    //         console.log(row);
                                                    //     } else {
                                                    //         setShowError(true);
                                                    //     }
                                                    // } catch (error) {
                                                    //     setShowError(true);
                                                    // }
                                                    openVisor(row["fileMimetype"], row["file"], row["id"])
                                                }}>{v}</td>
                                            }
                                        } else {
                                            if (col["format"]) {
                                                if (col["prop"] == "") {
                                                    v = row;
                                                }
                                                return <td key={index}>{col["format"](v)}</td>
                                            } else {
                                                return <td key={index}>{v}</td>
                                            }
                                        }

                                    }

                                    if (col["type"] == "boldText") {

                                        let v;
                                        if (col["nested"]) {
                                            v = row[col["prop"]][col.nested];
                                        } else {
                                            v = row[col["prop"]];
                                        }

                                        if (openVisor && col["openVisor"]) {
                                            if (col["format"]) {
                                                return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index} onClick={async () => {
                                                    // try {
                                                    //     let valor;
                                                    //     let resp;
                                                    //     try {
                                                    //         valor = JSON.parse(row["file"]);
                                                    //         valor = row.filenameKey;
                                                    //     } catch (e) {
                                                    //         valor = row.filenameKey;
                                                    //     }
                                                    //     if (valor == "archivo_dicom.dcm"){
                                                    //         valor = helperdcm(row.file)
                                                    //         console.log(helperdcm(row.file));
                                                    //     }
                                                    //     console.log(row, 'antes de entrar');
                                                    //     try {
                                                    //         resp = await previewer(valor);
                                                    //         console.log("Respuesta OK:", resp);
                                                    //     } catch (error) {
                                                    //         console.log("Error al hacer la petición:", error);
                                                    //     }
                                                    //     if (resp.ok) {
                                                    //         openVisor(row["fileMimetype"], row["file"], row["id"], row);
                                                    //         console.log(row);
                                                    //     } else {
                                                    //         setShowError(true);
                                                    //     }
                                                    // } catch (error) {
                                                    //     setShowError(true);
                                                    // }
                                                    openVisor(row["fileMimetype"], row["file"], row["id"], row);
                                                }}>{col["format"](v)}</td>
                                            } else {
                                                return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index} onClick={async () => {
                                                    // try {
                                                    //     let valor;
                                                    //     let resp;
                                                    //     try {
                                                    //         valor = JSON.parse(row["file"]);
                                                    //         valor = row.filenameKey;
                                                    //     } catch (e) {
                                                    //         valor = row.filenameKey;
                                                    //     }
                                                    //     if (valor == "archivo_dicom.dcm"){
                                                    //         valor = helperdcm(row.file)
                                                    //         console.log(helperdcm(row.file));
                                                    //     }
                                                    //     console.log(row, 'antes de entrar');
                                                    //     try {
                                                    //         resp = await previewer(valor);
                                                    //         console.log("Respuesta OK:", resp);
                                                    //     } catch (error) {
                                                    //         console.log("Error al hacer la petición:", error);
                                                    //     }
                                                    //     if (resp.ok) {
                                                    //         openVisor(row["fileMimetype"], row["file"], row["id"], row);
                                                    //         console.log(row);
                                                    //     } else {
                                                    //         setShowError(true);
                                                    //         // errorHandler(row)
                                                    //     }
                                                    //     // openVisor(row["fileMimetype"], row["file"], row["id"], row); 
                                                    // } catch (error) {
                                                    //     // console.log(error);
                                                    //     setShowError(true);
                                                    // }
                                                    openVisor(row["fileMimetype"], row["file"], row["id"], row);
                                                }}>{v}</td>
                                            }
                                        } else {
                                            if (col["format"]) {
                                                return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index}>{col["format"](v)}</td>
                                            } else {
                                                return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index}>{v}</td>
                                            }
                                        }

                                    }
                                    if (col["type"] == "func") {

                                        let v;
                                        if (col["nested"]) {
                                            v = row[col["prop"]][col.nested];
                                        } else {
                                            v = row[col["prop"]];
                                        }

                                        if (col["format"]) {
                                            return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index} onClick={() => { col["func"](v); }}>{col["placeholder"]}</td>
                                        } else {
                                            return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index} onClick={() => { col["func"](v); }}>{col["placeholder"]}</td>
                                        }

                                    }

                                    if (col["type"] == "link") {
                                        let v;
                                        if (col["nested"]) {
                                            v = row[col["prop"]][col.nested];
                                        } else if (col.placeholder) {
                                            v = col.placeholder;
                                        } else {
                                            v = row[col["prop"]];
                                        }

                                        if (col["urlProp"]) {
                                            if (col["format"]) {
                                                return <td key={index}><a href={row[col["urlProp"]]} target="_blank">{col["format"](v)}</a></td>;
                                                // <td key={index}><a href='' target="_blank" onClick={async (e) => {
                                                //     e.preventDefault();
                                                //     try {
                                                //         const valor = helperdcm(row.file);
                                                //         const resp = await previewer(valor);
                                                //         console.log(valor);

                                                //         if (resp.ok) {
                                                //             window.open(row[col["urlProp"]], '_blank');
                                                //         } else {
                                                //             setShowError(true);
                                                //         }
                                                //     } catch (error) {
                                                //         setShowError(true);
                                                //     }
                                                // }}>{col["format"](v)}</a></td>;
                                                // <td key={index}><a href={row[col["urlProp"]]} target="_blank">{col["format"](v)}</a></td>;
                                            } else {
                                                if (row[col["urlProp"]].includes(`["`)) {
                                                    return <td key={index}><a href={""} target="_blank" onClick={async (e) => {

                                                        e.preventDefault();
                                                        // try {
                                                        //     const valor = helperdcm(row.file);
                                                        //     const resp = await previewer(valor);
                                                        //     console.log(valor);
                                                        //     if (resp.ok) {
                                                        //         var downloadUrls = JSON.parse(row[col["urlProp"]]);
                                                        //         downloadUrls.forEach(function (value, idx) {
                                                        //             const response = {
                                                        //                 file: value,
                                                        //             };
                                                        //             setTimeout(() => {
                                                        //                 window.location.href = response.file;
                                                        //             }, idx * 100)
                                                        //         })
                                                        //     } else {
                                                        //         setShowError(true);
                                                        //     }

                                                        // } catch (error) {
                                                        //     setShowError(true);
                                                        // }


                                                        var downloadUrls = JSON.parse(row[col["urlProp"]]);
                                                        downloadUrls.forEach(function (value, idx) {
                                                            const response = {
                                                                file: value,
                                                            };
                                                            setTimeout(() => {
                                                                window.location.href = response.file;
                                                            }, idx * 100)
                                                        })

                                                    }}>{v}</a></td>;
                                                }
                                                // return <td key={index}><a href='' target="_blank" onClick={async (e) => {
                                                //     e.preventDefault();
                                                //     try {

                                                //         const valor = helperdcm(row.file);
                                                //         const resp = await previewer(valor);
                                                //         console.log(valor);


                                                //         if (resp.ok) {
                                                //             window.open(row[col["urlProp"]], '_blank');
                                                //         } else {
                                                //             setShowError(true);
                                                //         }

                                                //     } catch (error) {
                                                //         setShowError(true);
                                                //     }
                                                // }}>{v}</a></td>;

                                                return (
                                                    <td key={index}>
                                                        <a
                                                            href={row[col["urlProp"]]}
                                                            target="_blank"
                                                            onClick={(e) => {
                                                                const mimeType = row["fileMimetype"];

                                                                if (mimeType?.startsWith("image/")) {
                                                                    e.preventDefault();

                                                                    downloadFile(
                                                                        row[col["urlProp"]],
                                                                        row.filename || "archivo"
                                                                    );
                                                                }
                                                            }}
                                                        >
                                                            {v}
                                                        </a>
                                                    </td>
                                                );
                                            }
                                        } else if (col["customUrl"]) {
                                            return <td key={index}><a href={col["format"](row)} target="_blank">{row[col["text"]]}</a></td>;
                                        } else {
                                            let url = createUrl(col["url"], row);
                                            if (col["format"]) {
                                                return <td key={index}><Link to={url}>{col["format"](v)}</Link></td>
                                            } else {
                                                return <td key={index}><Link to={url}>{v}</Link></td>
                                            }
                                        }
                                    }

                                    if (col["type"] == "status") {
                                        let limit = 2;
                                        if (col["statusOrder"]) {
                                            limit = 4;
                                        }
                                        const id = col['customId'] ? row[col['customId']] : row["id"];
                                        const valueSelected = col['nested'] ? row[col['nested']]['statusId'] : row["statusId"];
                                        return (
                                            <td key={index}>
                                                <select className="statusSelect" value={valueSelected} onChange={(e) => { toggleStatus(e, id, col["url"]); }}>
                                                    {infoGeneral.status.map((status, index2) => {
                                                        if (status.id <= limit) {
                                                            return <option key={index2} value={status.id}>{status.name}</option>
                                                        }
                                                    })}
                                                </select>
                                            </td>
                                        );
                                    }

                                })}
                            </tr>;
                        })}
                    </tbody>
                </table>
            </div>
            {/* <Alerts visible={showError} title={alertTitle} message={alertMessage} onClose={cerrarError} showFooterButton={true} data={data} footerButtonContent={ <button onClick={cerrarError}>Cerrar</button> }/> */}
            {/* <Alerts visible={showError} title="Error interno" message="Ocurrió un error inesperado al procesar la solicitud." onClose={cerrarError} /> */}
        </>
    )
}

Tabla.propTypes = {
    info: PropTypes.object.isRequired,
    forceRender: PropTypes.number.isRequired
};